export const deliveryChannelsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
  {
    name: 'riskScore',
    label: 'Score',
  },
  {
    name: 'name',
    label: 'Type of delivery channel',
  },
];

export const deliveryChannelsListDefaultSorter = {};

export const deliveryChannelsListSchema = {};

export const deliveryChannelsListFiltersSchema = [];
